module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-16.921a1aa9.png";